import React, { useMemo } from 'react';

import { LevelsTableHeader } from './levels-table-header';
import { FreeDropDrop } from '../../../../../../models';
import { DropStatus } from '../../../../../../enums';
import { LevelsTableRow } from './levels-table-row';
import { useStore } from '../../../../../../hooks';


interface LevelsTableProps {

}

export const LevelsTable: React.FC<LevelsTableProps> = () => {

  const { freeDropStore } = useStore();
  const { levels, freeDropInfo } = freeDropStore;

  const sortedDrops = useMemo<Array<FreeDropDrop>>(() => {
    const drops = freeDropInfo?.drops;
    if (!drops) return [];
    const result: Array<FreeDropDrop> = [];
    drops.sort((a, b) => a.dropDate < b.dropDate ? -1 : 1);
    const upcomings = drops.filter((drop) => drop.status === DropStatus.Upcoming);
    const finished = drops.filter((drop) => drop.status === DropStatus.Finished);
    const [ next, ...restUpcomings ] = upcomings;
    if (next) {
      result.push({ ...next, status: DropStatus.Next });
    }
    return [ ...result, ...restUpcomings, ...finished ];
  }, [freeDropInfo]);

  return (
    <div className="free-drop-popup-table-wrp">
      <LevelsTableHeader levels={levels} />
      <div className="free-drop-popup-table-content">
        {
          sortedDrops.map(({ dropDate, status, tiers }) => (
            <LevelsTableRow
              tiers={tiers}
              key={dropDate}
              status={status}
              dropDate={dropDate}
              claimLimitPerDrop={freeDropInfo?.claimLimitPerDrop}
            />
          ))
        }
      </div>
    </div>
  );
};
